import { ref } from 'vue'
import { defineStore } from 'pinia'
import { PermissionsApi } from '@/apiGenerate/medserver';
import { medServerApiConfig } from '@/config/medserver-api.config';
import { useAppUserStore } from '@/stores/appUser';
import { ApiError } from '@/models/share.model';
import { toastError } from '@/utils/toast-utils';
import { useToast } from 'primevue';
import i18n from '@/i18n';

const { t } = i18n.global
const permissionsApi = new PermissionsApi(medServerApiConfig);

export const usePermissionsStore = defineStore('permissions', () => {
    const toast = useToast();
    const permissions = ref([]);
    const appUserStore = useAppUserStore();

    async function checkPermission(permissionToCheck: string): Promise<boolean> {
        if (permissions.value.length == 0) {
            await permissionsApi.getPermissions().then(response => {
                permissions.value = response;
            }).catch((error: ApiError) => {
                toastError(toast, {
                    summary: t('common.toast.error'),
                    detail: error.status ? t('error.' + error.status) : t('common.toast.error')
                });
            });
        }

        //Check if user has the right permissions.
        const res =  permissions.value.find((permission) => {

            const checkName = permission.name == permissionToCheck;
            let checkInsitute = false;

            if (permission.instituteUuid && appUserStore.currentHealthGroupMembership) {
                checkInsitute =  permission.instituteUuid == appUserStore.currentHealthGroupMembership.instituteWithRole.instituteWithRoleId;
            } else {
                checkInsitute = true;
            }

            return checkName && checkInsitute && permission.active;
        }) ;

        return res ? true : false;
    }

  return {  
    checkPermission
  }
})
